import { useCallback, useState } from 'react';
export var TabNavigationHotkeyEvent;
(function(TabNavigationHotkeyEvent) {
    TabNavigationHotkeyEvent[TabNavigationHotkeyEvent["NextTab"] = 0] = "NextTab";
    TabNavigationHotkeyEvent[TabNavigationHotkeyEvent["PreviousTab"] = 1] = "PreviousTab";
    TabNavigationHotkeyEvent[TabNavigationHotkeyEvent["FirstTab"] = 2] = "FirstTab";
    TabNavigationHotkeyEvent[TabNavigationHotkeyEvent["LastTab"] = 3] = "LastTab";
    TabNavigationHotkeyEvent[TabNavigationHotkeyEvent["ActivateTab"] = 4] = "ActivateTab";
})(TabNavigationHotkeyEvent || (TabNavigationHotkeyEvent = {}));
function keyboardEventToTabNavigationEvent(e) {
    switch(e.key){
        case ' ':
        case 'Space':
        case 'Enter':
            return TabNavigationHotkeyEvent.ActivateTab;
        case 'ArrowRight':
            return TabNavigationHotkeyEvent.NextTab;
        case 'ArrowLeft':
            return TabNavigationHotkeyEvent.PreviousTab;
        case 'Home':
            return TabNavigationHotkeyEvent.FirstTab;
        case 'End':
            return TabNavigationHotkeyEvent.LastTab;
        default:
            return undefined;
    }
}
export function useTabHotkeys(length) {
    const [focusedTabIndex, setFocusedTabIndex] = useState(null);
    const handleKeyDown = useCallback((e)=>{
        switch(keyboardEventToTabNavigationEvent(e)){
            case TabNavigationHotkeyEvent.FirstTab:
                e.preventDefault();
                setFocusedTabIndex(0);
                break;
            case TabNavigationHotkeyEvent.LastTab:
                e.preventDefault();
                setFocusedTabIndex(length - 1);
                break;
            case TabNavigationHotkeyEvent.NextTab:
                e.preventDefault();
                e.stopPropagation();
                if (focusedTabIndex !== null) {
                    focusedTabIndex === length - 1 ? setFocusedTabIndex(0) : setFocusedTabIndex(focusedTabIndex + 1);
                }
                break;
            case TabNavigationHotkeyEvent.PreviousTab:
                e.preventDefault();
                e.stopPropagation();
                if (focusedTabIndex !== null) {
                    focusedTabIndex === 0 ? setFocusedTabIndex(length - 1) : setFocusedTabIndex(focusedTabIndex - 1);
                }
                break;
            case TabNavigationHotkeyEvent.ActivateTab:
                break;
            default:
                break;
        }
    }, [
        focusedTabIndex,
        length
    ]);
    return {
        focusedTabIndex,
        onKeyDown: handleKeyDown,
        setFocusedTabIndex: (index)=>setFocusedTabIndex(index),
        clearFocusedTabIndex: ()=>setFocusedTabIndex(null)
    };
}
